import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g fill="none" fill-rule="evenodd">
      <path
        fill="currentColor"
        d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm4.735 9.472-.108.013c-3.06.575-6.2.575-9.263 0a.721.721 0 0 0-.556.117.737.737 0 0 0-.305.483.745.745 0 0 0 .592.866 26.87 26.87 0 0 0 3.2.399.49.49 0 0 1 .35.183.518.518 0 0 1 .112.391l-.093.813-.047.38-.055.374a15.922 15.922 0 0 1-.756 2.925l-.58 1.578-.023.077-.016.086a.749.749 0 0 0 .47.796c.185.07.389.063.568-.02a.743.743 0 0 0 .385-.418l.133-.272.277-.612.27-.617.174-.413c.115-.276.228-.553.337-.83l.2-.517.155.401c.334.851.7 1.71 1.101 2.586l.149.322.035.07.05.076a.722.722 0 0 0 1.083.103.743.743 0 0 0 .197-.809l-.581-1.579-.125-.359-.116-.36a16.098 16.098 0 0 1-.616-2.958l-.09-.817-.004-.067.002-.043a.515.515 0 0 1 .272-.408.488.488 0 0 1 .192-.054 26.703 26.703 0 0 0 3.174-.393.758.758 0 0 0 .447-.257.775.775 0 0 0 .183-.485.76.76 0 0 0-.267-.581.736.736 0 0 0-.615-.157Zm-3.424-3.929a1.838 1.838 0 0 0-2.627 0 1.901 1.901 0 0 0 0 2.66 1.838 1.838 0 0 0 2.627 0 1.901 1.901 0 0 0 0-2.66Z"
      />
      <circle
        cx={12}
        cy={12}
        r={10.364}
        stroke="currentColor"
        stroke-width={0.545}
      />
    </g>
  </svg>
);
export const ProfileIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
